let cached: boolean | undefined;

/** Browser-only. Cached for the page lifetime; call after mount, never during SSR. */
export function isWebGLSupported(): boolean {
    if (cached !== undefined) return cached;
    try {
        const canvas = document.createElement('canvas');
        cached = !!(canvas.getContext('webgl2') ?? canvas.getContext('webgl'));
    } catch {
        cached = false;
    }
    return cached;
}

export function markWebGLUnavailable(): void {
    cached = false;
}

/** three.js reports a failed context as "Error creating WebGL context" (and variants naming WebGL or the context). */
export function isWebGLFailure(error: unknown): boolean {
    const message = error instanceof Error ? error.message : String(error);
    return /webgl|rendering context|context lost/i.test(message);
}

/**
 * A render error of a 3D view. Only a real WebGL failure says something about the device and rules 3D
 * out for the rest of the session; any other error is a bug in our scene: the view falls back to 2D
 * for this mount and the error is reported like an uncaught one, which the apps' Sentry picks up.
 */
export function handleRenderError(error: unknown): void {
    if (isWebGLFailure(error)) {
        markWebGLUnavailable();
        return;
    }
    if (typeof reportError === 'function') reportError(error);
    else console.error(error);
}
